export const facebookGraphApiVersion = '3.3';
export const facebookAppId = '1276030352501030';

export const DASHBO_DOMAIN = 'www.dashbo.io';

export const ERROR_AD_ACCOUNT_NOT_LINKED_TO_AGENCY_CLIENT = "AD_ACCOUNT_NOT_LINKED_TO_AGENCY_CLIENT"

